import { createFileRoute } from "@tanstack/react-router"
import { lazy } from "react"
import LazyRoutePage from "../../../-LazyRoutePage"

const ProductLabelAssetsPage = lazy(
  () => import("../../../../components/WMS/Labels/ProductLabelAssetsPage"),
)

export const Route = createFileRoute("/_layout/WMS/products/label-assets")({
  component: ProductLabelAssetsRoute,
})

function ProductLabelAssetsRoute() {
  return (
    <LazyRoutePage>
      <ProductLabelAssetsPage />
    </LazyRoutePage>
  )
}
